import "./AboutPage.scss";
import Header from "../../components/Header/Header";

export const AboutPage = () => {
  return (
    <>
      <Header variant="public" />
      <main className="about-page">
        <section className="about-page__hero">
          <p className="about-page__eyebrow">О продукте</p>
          <h1 className="about-page__title">Neuro Boost для подготовки к собеседованиям</h1>
          <p className="about-page__subtitle">
            Neuro Boost помогает готовиться к техническим интервью, быстро повторять материал и увереннее проходить реальные собеседования.
          </p>
        </section>

        <section className="about-page__grid">
          <article className="about-page__card">
            <h2 className="about-page__cardTitle">Нейросеть-помощник</h2>
            <p className="about-page__cardText">
              Сервис помогает разобрать вопросы, собрать сильный ответ и быстрее ориентироваться в типовых интервью-сценариях.
            </p>
          </article>

          <article className="about-page__card">
            <h2 className="about-page__cardTitle">Курсы подготовки</h2>
            <p className="about-page__cardText">
              В продукте есть курсы для системной подготовки по темам, которые чаще всего встречаются на технических собеседованиях.
            </p>
          </article>

          <article className="about-page__card">
            <h2 className="about-page__cardTitle">Пробные собеседования</h2>
            <p className="about-page__cardText">
              Можно тренироваться в формате пробных интервью с нейросетью и постепенно снижать стресс перед реальной встречей.
            </p>
          </article>
        </section>
      </main>
    </>
  );
};
